import * as Progress from '@radix-ui/react-progress';
import { cn } from '@/shared/utils';

type LimitProgressProps = {
  used: number;
  limit: number;
  className?: string;
  indicatorClassName?: string;
};

export function LimitProgress({
  used,
  limit,
  className,
  indicatorClassName,
}: LimitProgressProps) {
  const value = limit > 0 ? Math.min((used / limit) * 100, 100) : 0;

  return (
    <Progress.Root
      className={cn(
        'relative h-[1.6rem] w-full overflow-hidden rounded-4xl bg-secondary-bg',
        className
      )}
      value={value}>
      <Progress.Indicator
        className={cn(
          'h-full w-full rounded-4xl bg-cyan transition-transform duration-300',
          indicatorClassName
        )}
        style={{ transform: `translateX(-${100 - value}%)` }}
      />
    </Progress.Root>
  );
}
